import React, { PropTypes } from 'react';

import { logo, inverseLogo } from './styles.module.css';

/**
 * Logo presentational component.
 */
const Logo = ({ className, inverse }) => (
  <svg
    className={[inverse ? inverseLogo : logo, className].join(' ')}
    style={{ display: 'none' /* CSS determines display */ }}
    viewBox="0 0 501.35 85.64"
  >
    <path d="M326.95 52.87v17.56H195.43V52.87H180.4v32.77h161.59V52.87h-15.04z" />
    <path d="M291.26 54.25a27.13 27.13 0 1 1 27.11-27.12 27.15 27.15 0 0 1-27.13 27.12m0-41.14a14 14 0 1 0 14 14 14 14 0 0 0-14-14M256.86 26.98a25.71 25.71 0 0 1-2.55 11.86 23.88 23.88 0 0 1-6.72 8.2 28 28 0 0 1-9.43 4.73 38.19 38.19 0 0 1-10.64 1.51H208V.97h18.92a46.88 46.88 0 0 1 10.94 1.29 27.48 27.48 0 0 1 9.61 4.29 22 22 0 0 1 6.8 8 26.92 26.92 0 0 1 2.59 12.42m-14 0a15.44 15.44 0 0 0-1.34-6.84 11.6 11.6 0 0 0-3.58-4.33 14.31 14.31 0 0 0-5.09-2.3 25 25 0 0 0-5.88-.69h-5.84v28.47h5.57a25 25 0 0 0 6.09-.72 14.22 14.22 0 0 0 5.16-2.37 11.8 11.8 0 0 0 3.58-4.39 15.5 15.5 0 0 0 1.34-6.81M0 .71v50.75h29.86v-5.79H6.15V.71H0zM46.09 6.5v15.8h19.35v5.79H46.09v17.58h22.62v5.79H40.02V.72h28.69V6.5H46.09zM115.7 6.5h-15.43v44.96h-6.14V6.5H78.7V.72h37V6.5zM131.17.71l-2.27 5.83h-4.93l.63-5.83h6.57zM139.84 37.31c.43 6.12 5.22 9.12 10.15 9.12 5.86 0 9.43-3.07 9.43-7.29 0-5.36-4.86-7.93-10.94-11-8.92-4.84-13.71-8.13-13.71-15.71 0-7.36 6.43-12.44 14.44-12.44 8.36 0 14.08 6.22 14.51 13.87h-6.15c-.43-4.72-3.71-8.08-8.36-8.08s-8.29 2.79-8.29 6.93c0 5.29 4 7.07 9.58 9.79 8.93 4.58 15 8.79 15 16.8s-6.72 12.87-15.51 12.87c-9.29 0-15.87-6.43-16.3-14.87h6.15zM449.94.72h6.14v50.74h-6.14zM386.32 6.5h-15.43v44.96h-6.15V6.5h-15.43V.72h37.01V6.5zM475.69 37.31c.43 6.12 5.22 9.12 10.15 9.12 5.86 0 9.43-3.07 9.43-7.29 0-5.36-4.86-7.93-10.94-11-8.96-4.84-13.72-8.13-13.72-15.71 0-7.36 6.43-12.44 14.44-12.44 8.36 0 14.08 6.22 14.51 13.87h-6.19c-.43-4.72-3.71-8.08-8.36-8.08s-8.29 2.79-8.29 6.93c0 5.29 4 7.07 9.58 9.79 8.93 4.57 15 8.79 15 16.79s-6.72 12.87-15.51 12.87c-9.29 0-15.87-6.43-16.3-14.87h6.15zM397.47 51.46V.72h6.08V22.3h19.35v5.79h-19.35v23.37h-6.08z" />
    <path d="M429.53 51.46V28.09h-19.34V22.3h19.34V.72h6.08v50.74h-6.08z" />
  </svg>
);

Logo.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean whether to use inverted styles.
   */
  inverse: PropTypes.bool.isRequired,
};

Logo.defaultProps = {
  className: '',
  inverse: false,
};

export default Logo;



// WEBPACK FOOTER //
// ./app/src/components/Logo/index.jsx